import { Divider, Flex, Text } from '@chakra-ui/react'
import { Button } from '../../../../../components/Button'
import { ModalBase } from '../../../../../components/ModalBase'

interface iModalProps {
  recomendacoes: number
  isOpen: boolean
  onRequestClose: () => void
  onCreate: (opcao: string) => void
}

export const ModalPDI: React.FC<iModalProps> = ({ isOpen, recomendacoes, onCreate, onRequestClose }) => {
  return (
        <ModalBase Width='52.688rem'
            onClose={onRequestClose}
            isOpen={isOpen}
            Titulo='Desenvolvimento do PDI'
        >
            <Flex padding={'1rem 1.5rem'}>
                <Text
                    fontSize={'1.5rem'}
                    fontWeight={'400'}
                >
                    Para esse novo ciclo você irá trabalhar {recomendacoes} competências.
                    <br />
                    Neste momento você deve selecionar se deseja iniciar um novo ciclo de acompanhamento, gerando um novo PDI, ou se deseja adicionar essas competências no PDI atual.
                </Text>
            </Flex>
            <Divider opacity={'100%'} border='2px solid var(--c4)' orientation='horizontal' />
            <Flex gap={'1rem'} justifyContent={'center'} padding='1rem 0'>
                <Button onClick={() => onCreate('1')} padding='2rem' VarColor='Rosa'>Iniciar um novo PDI </Button>
                <Button onClick={() => onCreate('2')} padding='2rem' VarColor='Azul'>Continuar no PDI atual<br /> (recomendado)</Button>
            </Flex>
        </ModalBase>
  )
}
